const HairstylishPackageData = [
  {
    title: "Paket Bronze",
    price: "RP 6.500.000",
    features: [
      "8x Pertemuan",
      "2x Perminggu",
      "6 Jam Perhari",
      "Included: Model, Garansi pasti bisa, Siap untuk bekerja"
    ],
    isPopular: false,
    borderColor: "border-amber-700"
  },
  {
    title: "Paket Silver",
    price: "RP 8.000.000",
    features: [
      "12x Pertemuan",
      "4x Perminggu",
      "6 Jam Perhari",
      "Included: Model, Garansi pasti bisa, Siap untuk bekerja"
    ],
    isPopular: false,
    borderColor: "border-gray-400"
  },

  {
    title: "Paket Gold",
    price: "RP 11.500.000",
    features: [
      "15x Pertemuan",
      "5x Perminggu",
      "6 Jam Perhari",
      "Included: Barbertools (papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
    ],
    isPopular: true,
    borderColor: "border-yellow-500"
  },

  // {
  //   title: "Paket Platinum",
  //   price: "RP 14.500.000",
  //   features: [
  //     "17x Pertemuan",
  //     "5x Perminggu",
  //     "6 Jam Perhari",
  //     "Included: Barbertools (alat cukur TUFT, papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
  //   ],
  //   isPopular: false,
  //   borderColor: "border-slate-300"
  // },

  // {
  //   title: "Paket Diamond",
  //   price: "RP 17.500.000",
  //   features: [
  //     "20x Pertemuan",
  //     "5x Perminggu",
  //     "6 Jam Perhari",
  //     "Included: Barbertools (alat cukur TUFT & WAHL, papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
  //   ],
  //   isPopular: false,
  //   borderColor: "border-sky-400"
  // },

  // {
  //   title: "Paket Private",
  //   price: "RP 35.000.000",
  //   features: [
  //     "25x Pertemuan",
  //     "5x Perminggu",
  //     "6 Jam Perhari",
  //     "Included: Barbertools (alat cukur TUFT & WAHL, papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
  //   ],
  //   isPopular: false,
  //   borderColor: "border-purple-600"
  // }
];

export default HairstylishPackageData